"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_1 = require("./app/app");
const events = __importStar(require("./app/events"));
const events_1 = require("./app/events");
const rest_1 = require("./app/rest");
const socket_1 = __importDefault(require("./app/socket"));
const wake_screen_1 = require("./app/wake-screen");
class Main {
    constructor() {
        this.socket = (0, socket_1.default)();
        this.params = new URLSearchParams(new URL(window.location.href).search);
        this.resize = () => {
            this.app.resize(window.innerWidth, window.innerHeight);
        };
        this.app = new app_1.App();
        this.init_com();
        (0, wake_screen_1.tryKeepAwake)();
        if (this.params.has("light"))
            document.getElementsByTagName('body')[0].className = "light";
    }
    init_com() {
        events.sub(events_1.On.new_text, "app", (data) => {
            this.app.saveMeta(data.meta);
            this.app.saveWordCount(data.words);
        });
        events.sub(events_1.On.reset, "reset", (data) => {
            this.init_com();
        });
        events.sub(events_1.On.reload, "reload", (data) => {
            window.location.reload();
        });
        (0, rest_1.getJsonData)('/words/current').then((data) => {
            this.app.saveMeta(data.meta);
            this.app.loadWordCount(data.words);
        }).catch(err => {
            console.error(err);
        });
    }
}
new Main();
